<template>
	<div id="app" ref="appRef">
		<router-view :key="$route.fullPath" />
	</div>
</template>

<script>
	export default {
		name: "App",
		data() {
			return {};
		},
		created() {},
		mounted() {
			if (this.isMobile()) {
				console.log("手机:" + this.$route.path);
				if (this.$route.path === "/") {
					this.$router.push("/index");
				}
			} else {
				console.log("pc端：" + this.$route.path);
				if (this.$route.path == "/") {
					this.$router.push("/homePage");
				}

				// 缩放
				this.bodyScale();
				// 设置样式
				this.setPcStyle();
			}
		},
		methods: {
			bodyScale() {
				let devicewidth = document.documentElement.clientWidth;
				let scale = devicewidth / 1920;
				document.body.style.zoom = scale;
			},
			// 判断方法
			isMobile() {
				let flag = navigator.userAgent.match(
					/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
				);
				return flag;
			},
			// 为pc端设置样式
			setPcStyle() {
				// this.$refs.appRef.style = "margin: -8px -8px auto;overflow-x: hidden;";
			}
		}
	};
</script>

<style>
	@import "../src/common/index.scss";

	body {
		margin: 0;
		padding: 0;
		overflow-x: hidden;
	}
</style>


// WEBPACK FOOTER //
// src/App.vue